import React from 'react'
import Pagination from 'react-bootstrap/Pagination'

export default class PagedView extends React.Component { 

	static defaultProps = { 
		pageSize: 50, 
		count: 100, 
		start: 1
	}

	constructor(props) { 
		super(props)

		this.state = { 
			item: [],
			start: this.props.start,
			buffer: 10,
			activeNumber: 1
		}
	}

	calculateItems() {
		console.log(`page size is ${this.props.pageSize} and count is ${this.props.count}`)
		
		
		this.setState({items: items})
	}

	onPageChange(number) { 
		this.setState({activeNumber: number})
		this.props.onPageChange(number)
	}

	onLessPages() { 
		this.setState({start: this.state.start - 1})
	}

	onMorePages(){
		this.setState({start: this.state.start + 1})
	}

	render() { 
		const totalCount = this.props.count
		const pageSize = this.props.pageSize
		const totalPages = totalCount / pageSize
		const shouldShowMore = this.state.start + this.state.buffer < totalPages + 1
		const shouldShowLess = this.state.start > 1
		const end = Math.min(totalPages, this.state.buffer)

		const items = []
		for (let number = this.state.start; number < this.state.start + end; number++) { 
			items.push(
				<Pagination.Item key={number} active={number == this.state.activeNumber}
				onClick={() => this.onPageChange(number)}>
				{number}
				</Pagination.Item>
			)
		}

		return (
			<div>
				{this.props.children}

				<Pagination style={{justifyContent: 'center'}}>
				{ shouldShowLess && <Pagination.Prev onClick={() => this.onLessPages()}/> }
				{items}
				{ shouldShowMore && <Pagination.Next onClick={() => this.onMorePages()}/> }
				</Pagination>

			</div>)
	}
}